(() => {
  const DEBUG = false; // ponelo en true si querés logs
  const norm = (s) => (s || "").replace(/\s+/g, " ").trim();

  // --- Anti-crash guards ---
  let LOCK = false;
  let pendingTitle = null;
  let timer = null;

  function getSelectedVariantTitle() {
    const vs = document.querySelector("variant-selects");
    if (!vs) return "";

    const opt = vs.querySelector("select option:checked");
    if (opt?.textContent) return norm(opt.textContent);

    const checked = vs.querySelector('input[type="radio"]:checked');
    if (checked?.value) return norm(checked.value);

    return "";
  }

function getMediaKeyFromItem(item) {
  // Preferimos SIEMPRE el alt del LI (sirve para imágenes + videos)
  const raw = norm(item.getAttribute("data-alt") || item.dataset?.alt);

  // fallback solo por si no existiera data-alt
  const img = item.querySelector("img");
  const altImg = norm(img?.getAttribute("alt"));

  const alt = raw || altImg;
  if (!alt) return "";

  // tolerancia: "Carta Natal | 1" / "Carta Natal - video" / "Carta Natal, algo"
  const key = alt.split("|")[0].split("—")[0].split("-")[0].split(",")[0].trim();
  return norm(key);
}


  function recalcSliders(scope) {
    // recalcula sliders solo dentro del gallery actual
    scope.querySelectorAll("slider-component").forEach((sc) => {
      try {
        sc.resetPages?.();
        sc.initPages?.();
        sc.update?.();
      } catch (e) {}
    });

    scope.querySelectorAll("thumbnail-slider").forEach((ts) => {
      try {
        ts.resetPages?.();
        ts.initPages?.();
        ts.update?.();
      } catch (e) {}
    });

    window.dispatchEvent(new Event("resize"));
  }

  function filterOneGallery(gallery, title) {
    const mediaList = gallery.querySelector(".product__media-list");
    if (!mediaList) return;

    const mediaItems = Array.from(mediaList.querySelectorAll("li.product__media-item"));
    if (!mediaItems.length) return;

    let anyMatch = false;
    const visibleMediaIds = [];

    // 1) Filtrar slides
    mediaItems.forEach((li) => {
      const key = getMediaKeyFromItem(li);
      const showAlways = key && key.toLowerCase() === "all";

      const matches = key === title;
      const shouldShow = showAlways || matches;

      li.toggleAttribute("hidden", !shouldShow);

      if (shouldShow) {
        const mid = li.getAttribute("data-media-id");
        if (mid) visibleMediaIds.push(mid);
      }

      if (matches) anyMatch = true;
      if (DEBUG && key) console.log("[variant-media-filter] key:", key, "=>", shouldShow ? "SHOW" : "HIDE");
    });

    // Fallback: si no matcheó nada, mostrar todo
    if (!anyMatch) {
      if (DEBUG) console.log("[variant-media-filter] no matches; showing all");
      mediaItems.forEach((li) => li.removeAttribute("hidden"));
      visibleMediaIds.length = 0;
      mediaItems.forEach((li) => {
        const mid = li.getAttribute("data-media-id");
        if (mid) visibleMediaIds.push(mid);
      });
    }

    // 2) Filtrar thumbnails SOLO dentro del scope correcto
    const thumbScope =
      gallery.querySelector("thumbnail-slider") ||
      gallery.querySelector(".thumbnail-slider") ||
      gallery;

    const thumbs = Array.from(
      thumbScope.querySelectorAll(".thumbnail-list__item, .thumbnail-list li, [data-target]")
    );

    thumbs.forEach((t) => {
      const target = t.getAttribute("data-target") || "";
      const href = t.querySelector("a")?.getAttribute("href") || "";
      const blob = `${target} ${href}`;

      // si no podemos mapear, no tocamos (evita romper UI)
      if (!target && !href) return;

      const showThumb = visibleMediaIds.some((id) => blob.includes(id));
      t.toggleAttribute("hidden", !showThumb);
    });

    // 3) Forzar media activa a la primera visible (solo si existe)
    const firstVisible = mediaItems.find((li) => !li.hasAttribute("hidden"));
    const firstId = firstVisible?.getAttribute("data-media-id");

    if (DEBUG) console.log("[variant-media-filter] first visible:", firstId);

    if (firstId && typeof gallery.setActiveMedia === "function") {
      // Antes de setActiveMedia, verificamos que ese id siga existiendo como thumb/slide
      const stillExists = mediaItems.some((li) => li.getAttribute("data-media-id") === firstId);
      if (stillExists) {
        try {
          gallery.setActiveMedia(firstId, true);
        } catch (e) {
          if (DEBUG) console.warn("[variant-media-filter] setActiveMedia failed", e);
        }
      }
    }

    // 4) Recalcular sliders
    recalcSliders(gallery);
  }

  function filterProductGalleriesNow(titleRaw) {
    const title = norm(titleRaw);
    if (!title) return;

    const galleries = document.querySelectorAll("media-gallery");
    if (DEBUG) console.log("[variant-media-filter] filtering for:", title, "galleries:", galleries.length);

    galleries.forEach((gallery) => filterOneGallery(gallery, title));
  }

  // Debounced + locked execution to avoid colliding with Dawn's internal updates
// Debounced + locked execution to avoid colliding with Dawn's internal updates
function scheduleFilter(title) {
  const t = norm(title);
  if (!t) return;

  pendingTitle = t;

  // debounce
  if (timer) clearTimeout(timer);

  timer = setTimeout(() => {
    if (LOCK) return;
    LOCK = true;

    // Esperamos a que Dawn termine de mutar DOM:
    // 2 RAF + pequeño timeout suelen evitar el "undefined.dataset" en media-gallery.js
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          try {
            filterProductGalleriesNow(pendingTitle);

            // ✅ Reintentar autoplay en videos del metaobjeto/descripcion
            document.querySelectorAll('.ma-video-wrap video, video.js-ma-autoplay').forEach((v) => {
              try {
                v.muted = true;
                v.playsInline = true;
                const p = v.play?.();
                if (p && typeof p.catch === 'function') p.catch(() => {});
              } catch (e) {}
            });

          } finally {
            LOCK = false;
          }
        }, 90);
      });
    });
  }, 80);
}


  function runInitial() {
    const t = getSelectedVariantTitle();
    if (DEBUG) console.log("[variant-media-filter] initial selected:", t);
    if (t) scheduleFilter(t);
  }

  document.addEventListener("DOMContentLoaded", () => {
    runInitial();

    document.addEventListener("change", (e) => {
      if (!e.target?.closest?.("variant-selects")) return;
      const t = getSelectedVariantTitle();
      if (DEBUG) console.log("[variant-media-filter] change:", t);
      if (t) scheduleFilter(t);
    });

    document.addEventListener("variant:change", (e) => {
      const v = e.detail?.variant;
      const t = norm(v?.title) || getSelectedVariantTitle();
      if (DEBUG) console.log("[variant-media-filter] variant:change:", t);
      if (t) scheduleFilter(t);
    });
  });
})();
